import { Stack } from "@mui/material";
import { listBrands } from "api/listBrands";
import useDebounce from "hooks/useDebounce";
import { useEffect, useState } from "react";
import SearchInput from "./SearchInput";
import SearchResultsList from "./SearchResultsList";

function SearchSection({ setFilterSearch, setMachineSearch, setTypeSearch }) {
  const [brandList, setBrandList] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [searchMachine, setSearchMachine] = useState("");
  const [searchType, setSearchType] = useState("");
  const [stopSearching, setStopSearching] = useState(false);

  const debouncedSearchMachine = useDebounce(searchMachine, 750);
  const debouncedSearchType = useDebounce(searchType, 750);

  const sanitizeSearchTerm = (term) => {
    return term.trim().replace(/\s+/g, " ");
  };

  useEffect(() => {
    setFilterSearch(searchFilter);
  }, [searchFilter, setFilterSearch]);

  useEffect(() => {
    setTypeSearch(debouncedSearchType);
  }, [debouncedSearchType, setTypeSearch]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        if (!debouncedSearchMachine || stopSearching) {
          setBrandList([]);
          return;
        }
        const response = await listBrands(
          debouncedSearchMachine,
          controller.signal
        );

        if (response && response.data) {
          const brands = response.data?.data ?? [];
          setBrandList(brands);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setBrandList([]);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [debouncedSearchMachine, setMachineSearch, stopSearching]);

  const handleChangeFixed = (setValue, clearValue, value) => {
    const sanitizedValue = sanitizeSearchTerm(value);
    setValue(sanitizedValue);
    setStopSearching(false);
    if (clearValue) clearValue("");
  };

  const handleBrandClick = (brandCode, brandName) => {
    setMachineSearch(brandCode);
    setSearchMachine(brandName);
    setStopSearching(true);
  };

  const handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      handleChangeFixed(setSearchFilter, setSearchMachine, e.target.value);
      e.target.blur(); // removes focus from input thus hiding the keyboard on mobile
    }
  };

  return (
    <Stack direction="column" spacing={2} sx={{ margin: 2, width: "100%" }}>
      <SearchInput
        label="Find dit filtre her"
        placeholder="Find dit filtre her"
        onKeyDown={handleFilterKeyDown}
        search={true}
        onClick={(value) =>
          handleChangeFixed(setSearchFilter, setSearchMachine, value)
        }
      />
      <div style={{ position: "relative" }}>
        <SearchInput
          label="Find din maskine her"
          placeholder="Find din maskine her"
          value={searchMachine}
          onChange={(e) =>
            handleChangeFixed(setSearchMachine, setSearchFilter, e.target.value)
          }
        />
        {!!brandList.length && (
          <SearchResultsList
            results={brandList}
            onResultClick={handleBrandClick}
          />
        )}
      </div>
      <SearchInput
        label="Find din type her"
        placeholder="Find din type her"
        value={searchType}
        onChange={(e) => setSearchType(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.target.blur();
          }
        }}
        disabled={!debouncedSearchMachine}
        search={true}
        onClick={(e) => e.target.blur()}
      />
    </Stack>
  );
}

export default SearchSection;
